import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-4 bg-white" data-id="element-297">
      <div className="max-w-lg md:max-w-2xl mx-auto" data-id="element-298">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-8 md:p-10 rounded-3xl border-2 border-[#4CAF50] shadow-lg text-center relative overflow-hidden" data-id="element-299">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#4CAF50]" data-id="element-300"></div>

          <div className="flex justify-center mb-6" data-id="element-301">
            <div className="bg-[#E8F5E9] p-4 rounded-full" data-id="element-302">
              <ShieldCheck className="w-12 h-12 text-[#4CAF50]" data-id="element-303" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-4" data-id="element-304">
            GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <p className="text-lg text-gray-700 mb-4 font-medium" data-id="element-305">
            Si en 7 días sientes que NutriPeques no te aportó valor, te
            devolvemos el 100% de tu inversión.
          </p>

          <p className="text-gray-600 mb-6" data-id="element-306">
            Sin preguntas. Sin complicaciones.
          </p>

          <p className="text-[#2E7D32] font-bold italic" data-id="element-307">
            Porque confiamos en lo que hemos creado.
          </p>
        </motion.div>
      </div>
    </section>;
}